// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AvailabilityMessageType, CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { TypographyProps } from "@insite/mobius/Typography";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export const cartLineBreakpoints = {
    md: 1200,
    sm: 550,
    xs: "xs",
};

export const cartLinesHeaderGroup = {
    available: "Immediately Available",
    otherAvailability: "Contact us for Availability",
};

export const cartLinesGroupingHandler = (cartLines: CartLineModel[]) => {
    const cartLinesAvailabilityGroup: CartLineModel[] = [];
    const cartLinesOtherGroup =
        cartLines?.filter(item => {
            if (item.availability?.messageType !== AvailabilityMessageType.OutOfStock) {
                cartLinesAvailabilityGroup.push(item);
                return false;
            }
            return true;
        }) ?? [];
    return { cartLinesAvailabilityGroup, cartLinesOtherGroup };
};

export const orderSummaryValueTextStyle = (bold?: boolean, cssProps?: StyledProp<any>) =>
    ({
        css: css`
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            padding-bottom: 25px;
            ${bold && `font-weight: bold;`}
            ${cssProps}
        `,
    } as TypographyProps);

export const orderSummaryTotalStyle = (type: "label" | "value", cssProps?: StyledProp<any>): TypographyProps =>
    type === "label"
        ? {
              css: css`
                  font-size: 20px;
                  font-weight: bold;
                  letter-spacing: 0;
                  line-height: 22px;
                  ${cssProps}
              `,
          }
        : {
              css: css`
                  font-size: 24px;
                  font-weight: bold;
                  letter-spacing: 0;
                  line-height: 28px;
                  ${cssProps}
              `,
          };
